import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mantine/core";

interface AddConditionButtonProps {
  onClick: () => void;
}

export const AddConditionButton = ({ onClick }: AddConditionButtonProps) => {
  return (
    <Button
      variant="transparent"
      size="xs"
      className="w-min px-0"
      onClick={onClick}
      rightSection={<FontAwesomeIcon icon={faPlus} />}
    >
      ADD CONDITION
    </Button>
  );
};
